<script lang="ts">
    import {onMount} from "svelte";
    import ButtonGroup from "$components/Elements/ButtonGroup.svelte";


    onMount(async () => {

        setTimeout(() => {
            let google = window.google;
            let map = document.getElementById("map-canvas");
            const mapCenter = new google.maps.LatLng(48.2095135,16.3670617);
            const location1010 = new google.maps.LatLng(48.2073829,16.369103);
            const locationOffice = new google.maps.LatLng(48.210851896467645,16.372465260341375);
            const mapOptions = {
                zoom: 15,
                scrollwheel: false,
                center: mapCenter,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,

                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ],
            };

            map = new google.maps.Map(map, mapOptions);

            const marker = new google.maps.Marker({
                position: location1010,
                map: map,
                animation: google.maps.Animation.DROP,
                title: 'Location 1010',
            });

            const marker2 = new google.maps.Marker({
                position: locationOffice,
                map: map,
                animation: google.maps.Animation.DROP,
                title: 'Head Office',
            });
        }, 1000)


    });

    /*let index = 0;
    let section = {
        title: 'Our pawnshops',
        description: 'Visit our pawnshops at any time during the working hours to get quick cash or shop our collection of watches, fine jewelry and other valuables. Our friendly and respectful staff will gladly help you and answer any questions.',
        cta: []
    }*/

    export let index: number;
    export let section: Section;
</script>


<svelte:head>
    <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDupxMrY12d6pEE5gz-vZRaLZawvn4ZCPA"></script>
</svelte:head>
<div class="wrapper ">

</div>

<div class="relative isolate pt-12" class:bg-gray-200={index !== 0}>
    <div class="py-0 sm:py-20 lg:pb-40">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="">
                {#if index === 0}
                    <h1 class="text-5xl font-bold tracking-tight sm:text-6xl font-display">
                        {section.title}
                    </h1>
                {:else}
                    <h2 class="text-4xl font-bold tracking-tight sm:text-5xl font-display">
                        {section.title}
                    </h2>
                {/if}

                <p class="mt-6 text-lg leading-8"> {section.description}</p>


            </div>
            <div class="mt-16 flow-root sm:mt-24">
                <div class="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4 bg-base-100">
                    <div id="map-canvas" class="h-96 lg:h-[30rem] w-full rounded-md shadow-2xl ring-1 ring-gray-900/10"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    #map-canvas {
        background: linear-gradient(-90deg, #ccc, #ddd, #ccc, #ddd);
        background-size: 400% 400%;
        animation: gradient 5s ease infinite;
    }
</style>
